import { MESSAGES } from "../../messages";
import { Metric } from "../../models/tableModels";

export const placeholderData: Metric[] = ((): Metric[] => {
  const data: Metric[] = [];
  const count = 14;
  for (let i = 1; i <= count; i++) {
    data.push({
      metric_id: MESSAGES.NOT_AVAILABLE,
      is_index: i % 2 === 0,
      value_numeric: 0,
      value_text: "",
      portfolio_index_id: `index${i}`,
      Compass_Metric_Display_Name: MESSAGES.NOT_AVAILABLE,
      currency: MESSAGES.NOT_AVAILABLE,
      added_on: new Date().toISOString(),
      fund_aum: 0,
      tCO2e_1_5C_or_1_75C: 0,
      tCO2e_2C: 0,
      tCO2e_2_7C_or_3C: 0,
    });
  }
  return data;
})();
